module.exports = __webpack_public_path__ + "img/logo_ucat2.2a78e669.png";